import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventDispatcherService {
  private readonly WAIT_TIME: number = 2000;
  private readonly WAIT_TIME_AFTER_DISPATCH: number = this.WAIT_TIME + 3000;
  private canDispatchEvent: boolean = true;
  private lastEventUniqueId: string;
  

  dispatchEvent(event: CustomEvent, uniqueId: string = ""): boolean {
    if (!this.canDispatchEvent) {
      console.warn('Event dispatching is currently disabled.');
      return false;
    }

    if (uniqueId === this.lastEventUniqueId) {
      console.warn('Event with the same uniqueId has already been dispatched:', uniqueId);
      return false;
    }

    this.lastEventUniqueId = uniqueId;
    this.canDispatchEvent = false;

    setTimeout(() => {
      document.dispatchEvent(event);
    }, this.WAIT_TIME);
    
    setTimeout(() => {
       this.canDispatchEvent = true;
    }, this.WAIT_TIME_AFTER_DISPATCH);

    return true;
  }
}
